import script from "./journalButton.ce.vue?vue&type=script&setup=true&lang=js"
export * from "./journalButton.ce.vue?vue&type=script&setup=true&lang=js"

import _style_0 from "./journalButton.ce.vue?vue&type=style&index=0&id=6837f605&inline&lang=css"

import exportComponent from "/home/runner/work/Safejournal/Safejournal/safejournal/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['styles',[_style_0]]])

export default __exports__